import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

const defaultStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block',
}

interface ITruncatedProps {
  children: React.ReactNode
  title?: string
  style?: Rule
}

const reactChildrenToString = (children: React.ReactNode): string => {
  return ([] as React.ReactNode[])
    .concat(React.Children.toArray(children))
    .map(child =>
      typeof child === 'string'
        ? child
        : React.isValidElement(child) && child.props && child.props.children
        ? reactChildrenToString(child.props.children)
        : ''
    )
    .join('')
}

export function Truncated({ children, title, style }: ITruncatedProps) {
  const element = React.useRef<HTMLSpanElement | null>(null)
  const [truncated, setTruncated] = React.useState(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (element.current) {
      setTruncated(element.current.offsetWidth < element.current.scrollWidth)
    }
  })

  React.useEffect(() => {
    const handleResize = () => {
      if (element.current) {
        setTruncated(element.current.offsetWidth < element.current.scrollWidth)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <span
      ref={element}
      title={truncated ? title || reactChildrenToString(children) : undefined}
      {...css(defaultStyle, style)}
    >
      {children}
    </span>
  )
}

Truncated.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  style: PropTypes.object,
}
